import Cookies from 'js-cookie'

const TOKEN_KEY = 'member_token'
const USER_KEY = 'member_user'

// 获取Token
export function getToken() {
  return Cookies.get(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
}

// 设置Token
export function setToken(token) {
  Cookies.set(TOKEN_KEY, token)
  localStorage.setItem(TOKEN_KEY, token)
}

// 移除Token
export function removeToken() {
  Cookies.remove(TOKEN_KEY)
  localStorage.removeItem(TOKEN_KEY)
}

// 获取用户信息（页面刷新恢复）
export function getUserInfo() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

// 保存用户信息
export function setUserInfo(info) {
  localStorage.setItem(USER_KEY, JSON.stringify(info))
}

// 移除用户信息
export function removeUserInfo() {
  localStorage.removeItem(USER_KEY)
}
